import clsx from 'clsx'
import { ComponentProps, FC, useMemo } from 'react'
import { Img } from 'src/images'
import { ICampaignModel } from 'src/interfaces'
import { CampaignUtils } from 'src/utils'

interface IProps extends ComponentProps<'div'> {
  campaign: Partial<ICampaignModel>
}

export const JobInfo: FC<IProps> = ({
  campaign,
  ...props
}) => {
  const parsedJob = useMemo(() => CampaignUtils.parse(campaign), [campaign])
  const logoUrl = useMemo(() => CampaignUtils.getLogoUrl(campaign), [campaign])

  return (
    <div {...props} className={clsx('fx-column gap-2', props.className)}>
      <div className="fx fx-ai-center fx-jc-space-between fx-wrap-wrap gap-2">
        <div className="fx fx-ai-center gap-2">
          {logoUrl && (
            <Img
              src={logoUrl}
              width={17}
              height={17}
              alt="logo"
              className="round-10 bg-neutral-20"
              style={{ objectFit: 'contain' }}
            />
          )}

          {parsedJob.companyName && (
            <span
              title={parsedJob.companyName}
              className="fw-600 fs-12 txt-black-01 oneline-text"
              style={{ maxWidth: '155px' }}
            >
              {parsedJob.companyName}
            </span>
          )}
        </div>

        {parsedJob.salary && (
          <div className="body-12 txt-grey-01">
            {parsedJob.salary}
            {parsedJob.salaryRate}
          </div>
        )}
      </div>

      <div className="body-12 txt-black-01 oneline-text">
        {[campaign.location, parsedJob.locationType].filter(Boolean).join(' - ') || '--'}
      </div>
    </div>
  )
}
